import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { ShareResponse } from '../../share';

const { Option } = Select;

interface FormSelectProps {
  label: string;
  name: string;
  placeholder?: string;
  value: string | undefined;
  options?: ShareResponse[] | null;
  optionDefault?: any;
  error?: string | undefined;
  touched?: boolean | undefined;
  onChange: (value: string) => void;
  onBlur: () => void;
  showSearch?: boolean;
  disabled?: boolean;
}

const FormSelect: React.FC<FormSelectProps> = ({
  disabled,
  label,
  name,
  placeholder = 'Seleccione...',
  value,
  options = [],
  optionDefault = [],
  error,
  touched,
  onChange,
  onBlur,
  showSearch = false,
}) => {
  const safeOptions = Array.isArray(options) ? options : [];
  const safeOption = optionDefault ? optionDefault : {};

  return (
    <Form.Item
      label={<span className="custom-label">{label}</span>}
      validateStatus={touched && error ? 'error' : undefined}
      help={touched && error}
      labelCol={{ span: 24 }}
      className="custom-form-item"
    >
      <Select
        disabled={disabled}
        placeholder={placeholder}
        value={value || safeOption?.id || undefined}
        onChange={onChange}
        onBlur={onBlur}
        size="middle"
        showSearch={true}
        optionFilterProp="children"
        filterOption={(input, option) => {
          const label =
            typeof option?.children === 'string'
              ? option.children
              : String(option?.children);
          return label.toLowerCase().includes(input.toLowerCase());
        }}
      >
        <Option value="" disabled>
          {placeholder}
        </Option>
        {safeOptions.map((option) => (
          <Option
            key={option.id}
            value={option.id}
            disabled={option.disabled && value !== option.id}
          >
            {option.document ? option.document + " - " : ""}
            {option.name ? option.name + " " : ""}
            {option.last_name ? option.last_name + " " : ""}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FormSelect;
